// Segment analytics has been REMOVED from the app. The Facebook / Google client-id helpers below are
// intentionally KEPT: they read the _fbp / _ga cookies and are consumed by App.vue and the
// registration flow (appFacebookId / appGoogleClientId) as marketing attribution sent to the
// Brickwise backend — this is independent of Segment.

export let fbp = '';
export let ga = '';

/**
 * Get cookie value with name
 */
const getCookie = (cname: string) => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  if (!ca) return;
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

/**
 * Retrieve facebook and google client ids from cookies. These are sent to the Brickwise backend as
 * marketing attribution (App.vue / registration) — NOT to Segment.
 */
const initAnalytics = () => {
  fbp = getCookie('_fbp') || '';
  ga = localStorage.getItem('appGoogleClientId') || getCookie('_ga') || '';
  ga = ga.replace('GA1.1.', '').replace('GA1.2.', '');
  setTimeout(() => {
    fbp = getCookie('_fbp') || '';
    ga = localStorage.getItem('appGoogleClientId') || getCookie('_ga') || '';
    ga = ga.replace('GA1.1.', '').replace('GA1.2.', '');
  }, 1000);
  setTimeout(() => {
    fbp = getCookie('_fbp') || '';
    ga = localStorage.getItem('appGoogleClientId') || getCookie('_ga') || '';
    ga = ga.replace('GA1.1.', '').replace('GA1.2.', '');
  }, 2000);
  setTimeout(() => {
    fbp = getCookie('_fbp') || '';
    ga = localStorage.getItem('appGoogleClientId') || getCookie('_ga') || '';
    ga = ga.replace('GA1.1.', '').replace('GA1.2.', '');
  }, 5000);
};

initAnalytics();
